<template>
  <router-view v-if="applyData"/>
</template>

<script>
import store from '@/store'
import { parse, format, addDays, isBefore } from 'date-fns'
import { mapState } from 'vuex'
import { parseJwt } from '@/libs/utils'
import { getAuthToken } from '@/libs/auth-helper'
import { DOCUMENT_TITLE_PREFIX } from '@/libs/constants'
import { getApply } from '@/api/apply'
import { getReportPeriod } from '@/api/report'
import { getDialog } from '@/libs/vue-utils'

const openDialog = getDialog('dialogType')

function loadApplyData (aid, query) {
  return Promise.all([
    getApply(aid),
    getReportPeriod(aid)
  ]).then(result => {
    const apply = result[0]
    const period = result[1]

    if (!apply || !apply.meta.canViewReport) {
      return null
    }

    const tokenData = parseJwt(getAuthToken().accessToken)
    const userId = tokenData.identity.user_id
    const userNum = tokenData.identity.user_num
    const siteCodeList = store.state.userData.siteCodeList

    // if (userId !== 'admin' && !apply.meta.shared) {
    //   if (!siteCodeList.includes('ALL') && !siteCodeList.includes(apply.siteCode)) {
    //     return null
    //   }
    // }

    const dateFormat = 'YYYY-MM-DD'
    const minDate = parse(period.minDate)
    const maxDate = parse(period.maxDate)
    let startDate = addDays(maxDate, -6)
    let endDate

    if (isBefore(startDate, minDate)) {
      startDate = parse(minDate)
    }

    if (query.startDate) {
      startDate = parse(query.startDate)
    }

    if (query.endDate) {
      endDate = parse(query.endDate)
    }

    store.commit('setApplyData', apply)
    store.commit('setReportPeriod', {
      start: format(startDate, dateFormat),
      end: format(endDate || maxDate, dateFormat),
      min: format(minDate, dateFormat),
      max: format(maxDate, dateFormat)
    })
    document.title = `${DOCUMENT_TITLE_PREFIX} - Report(${apply.pageName})`
    return apply
  })
}

export default {
  name: 'Report',
  created () {
  },
  computed: {
    ...mapState([
      'applyData',
      'userData'
    ])
  },
  methods: {
  },
  beforeRouteUpdate (to, from, next) {
    if (to.params.aid && from.params.aid !== to.params.aid) {
      loadApplyData(to.params.aid, to.query).then(result => {
        if (!result) {
          openDialog('report.invalidRequest').then(() => {
            return next({ name: 'dashboard' })
          })
        } else {
          return next()
        }
      }).catch(err => {
        console.error(err)
        return next({ name: 'dashboard' })
      })
    } else {
      return next()
    }
  },
  beforeRouteEnter (to, from, next) {
    const aid = to.params.aid

    if (!aid) {
      return next({ name: 'dashboard' })
    } else {
      loadApplyData(aid, to.query).then(result => {
        if (!result) {
          openDialog('report.invalidRequest').then(() => {
            return next({ name: 'dashboard' })
          })
        } else {
          return next()
        }
      }).catch(err => {
        console.error(err)
        return next({ name: 'dashboard' })
      })
    }
  }
}
</script>

<style>

</style>
